var React = require('react');

function X (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.6431 6.29102H17.5723L13.3576 11.1764L18.316 17.8242H14.4335L11.3927 13.7923L7.91329 17.8242H5.98279L10.4909 12.5988L5.73438 6.29102H9.71527L12.464 9.97626L15.6431 6.29102ZM14.966 16.6531H16.0351L9.13445 7.40065H7.98735L14.966 16.6531Z","fill":"currentColor"}));
}

X.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"};

module.exports = X;

X.default = X;
